import { IconButton } from "@mui/material";
import React, { useState, useEffect } from "react";
import { EventEmitter } from "../../../event";
import FullscreenIcon from '@mui/icons-material/Fullscreen';
import MyWindowPortal from './MyWindowPortal'
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { AntSwitch, PrettoSlider } from "../../common/codeHelper";
import { getImage } from "../../../service/api.service";
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import DcmDialogWOCornerstone from "./DcmDialogWOCornerstone";
// import { ImageLazyLoad } from "../../common/ImageLazyLoad";

const styles = {
    bottomRightStyle: {
        bottom: "5px",
        right: "5px",
        position: "absolute",
        color: "white"
    },
    fulldivStyle: {
        // width: "512px",
        // height: "90vh",
        position: "relative",
        color: "white"
    },
    divStyle: {
        // width: "512px",
        // height: "175px",
        // height: (window.innerWidth / 100) * 23.86 + 'px',
        // width: (window.innerWidth / 100) * 23.86 + 'px',
        position: "relative",
        color: "white"
    },
    noDataDiv: {
        height: "275px",
        textAlign: 'center',
        alignItems: 'center',
        display: 'grid'
    },
    topRightStyle: {
        top: "5px",
        right: "0px",
        color: '#fff',
        position: "absolute",
    },
    topLeftStyle: {
        top: "4px",
        left: "5px",
        position: "absolute",
        color: "white",
        fontSize: "10px",
        background: "#2b8f35",
        border: "1px solid #fff",
        borderRadius: "25px",
        height: "31px",
        width: "30px",
        zIndex: "2",
    },
    inputLabel: {
        margin: "0",
        fontWeight: "400",
        fontSize: "1rem",
        lineHeight: "1.5",
        letterSpacing: '0.00938em'
    }
}

// The Header creates links that can be used to navigate
// between routes.


let state = {
    imageId: '',
    image: '',
    currentImageIndex: 0,
    aixalSliceData: ''
};

function AxialView(props) {
    let simpleViewerElement;
    const [showOriginal, setShowOriginal] = useState(true);
    const [showWindowPortal, setShowWindowPortal] = useState(false);
    const [axialImage, setAxialImage] = useState(state.image);
    
    const [extraData, setExtraData] = React.useState({ heading: '', height: '120', width: '120' });
    // let unmounted = false;
    state = {
        imageId: state.imageId,
        image: state.image,
        aixalSliceData: props.sliceData.axialImageData,
        currentImageIndex: state.currentImageIndex
    }
    const [idToFetchData, setIdToFetchData] = React.useState(state.imageId);
    EventEmitter.subscribe("requesFullScreenElem", (type) => {
        if (type === 'original') {
            if (simpleViewerElement) {
                if (simpleViewerElement.requestFullscreen) {
                    simpleViewerElement.requestFullscreen();
                } else if (simpleViewerElement.webkitRequestFullscreen) { /* Safari */
                    simpleViewerElement.webkitRequestFullscreen();
                } else if (simpleViewerElement.msRequestFullscreen) { /* IE11 */
                    simpleViewerElement.msRequestFullscreen();
                }
            }
        }
    })

    useEffect(() => {
        let unmounted = false;
        loadImage(state.currentImageIndex, showOriginal);
        EventEmitter.subscribe("dropdownSelectChangeAxial", (event) => {
            state.currentImageIndex = 0;
            state.aixalSliceData = event;
            if (!unmounted)
                loadImage(0, showOriginal);
        });

        EventEmitter.subscribe("sliceDataChange", (event) => {
            state.currentImageIndex = 0;
            state.aixalSliceData = event;
            if (!unmounted)
                loadImage(0, showOriginal);
        })

        // }
        return () => { unmounted = true };
    });

    const loadImage = (id, show) => {

        if (state.aixalSliceData[id]) {
            let key = '';
            let heading = 'Axial Slice:' + (state.currentImageIndex + 1) + ' (ML Analysis)';
 
            if (show) {
                key = state.aixalSliceData[id].fileIds[0];
                heading = 'Axial Slice:' + (state.currentImageIndex + 1) + '  (Original)'
            } else {
                key = state.aixalSliceData[id].fileIds[1];
            }
            if (state.imageId !== key) {
                 state.imageId = key;
                setIdToFetchData(key);
                 getImage(key, (resp) => {
                    state.image = 'data: image / png; base64,' + resp.fileData;
                    setAxialImage(state.image);
                    if (extraData.heading !== heading)
                        setExtraData({
                            heading: heading,
                            height: resp.fileProperties.imageHeight,
                            width: resp.fileProperties.imageWidth,
                            value: '',
                            key: ''
                        });
                })
            }
        }

    }


    function requestFullScreenElem(type) {
        if (type === 'axial') {
            if (simpleViewerElement) {
                if (simpleViewerElement.requestFullscreen) {
                    simpleViewerElement.requestFullscreen();
                } else if (simpleViewerElement.webkitRequestFullscreen) { /* Safari */
                    simpleViewerElement.webkitRequestFullscreen();
                } else if (simpleViewerElement.msRequestFullscreen) { /* IE11 */
                    simpleViewerElement.msRequestFullscreen();
                }
            }
        }
    }
    function handleToggleClick() {
        setShowOriginal(!showOriginal);
        loadImage(state.currentImageIndex, !showOriginal)

    }

    function requestNewTabWindow() {
        setShowWindowPortal(!showWindowPortal);
    }

    const handleSetShowWindowPortal = () => {
        setShowWindowPortal(!showWindowPortal);
    };

    const handleChangeSlider = (event) => {
        if (state.currentImageIndex !== event.target.value - 1) {
            state.currentImageIndex = event.target.value - 1;
            loadImage(event.target.value - 1, showOriginal);
        }
    }



    return (
        <div className="axial-view">
            {
                state.aixalSliceData.length > 0 &&
                <div
                    className="viewportElement"
                    style={showWindowPortal ? styles.fulldivStyle : styles.divStyle}
                >
                    {/* <div style={styles.topRightStyle}>
                        <IconButton
                            color="inherit"
                            aria-label="Full Screen"
                            edge="start"
                            onClick={() => requestFullScreenElem('axial')}
                        >
                            <FullscreenIcon />
                        </IconButton>
                    </div> */}
                    <div style={styles.topLeftStyle}>
                            <DcmDialogWOCornerstone image={idToFetchData} extraData={extraData}></DcmDialogWOCornerstone>
                        {/* <IconButton
                            color="inherit"
                            aria-label="New Screen"
                            edge="start"
                            onClick={() => requestNewTabWindow('sagittal')}
                        >
                            <OpenInNewIcon />
                        </IconButton> */}
                    </div>
                    <img alt="Thumbnail" className="w-full h-full drop-shadow-md " src={axialImage}
                        ref={(input) => {
                            simpleViewerElement = input;
                        }}
                    />
                    {/* <ImageLazyLoad style={{ width: 400, height: 300 }}
                        placeholderImg=" data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAARMAAAC3CAMAAAAGjUrGAAAAM1BMVEXExMT////BwcHo6Oju7u7Y2Nj5+fn09PTJycn8/PzPz8/GxsbU1NTMzMzl5eXp6enf3984nfntAAADJ0lEQVR4nO3cjZKaMBRAYYiIIL/v/7SLii6SEEGJeC/n60yn0+q4OcUAUYgiAAAAAAAAAAAAAAAAAAAAAAAA4OcZU1VZIFVhzNbjW84UzSkOJ0/arUe4mDnmAYtcpWdZm4o5hi7Syc9bD3MJU34hSRcl23qgS4ScSgaSrcc531feOVfl1kOdrbhvJskhkKR/gaOYabZIbz9xbYJphDY5hXuF+7uTJv9oYqOJTVGT1U7ctDQporJts6JY4xVUNDFZk1/+Nk9P5QrjMK38Jk+nycnnpykKtpP7f2sv/TiK/CajJN2/fBpFfBPHysGnu2nxTVwrB9VnryC+ydlOEjefDUZ6E3NwNElfHqZ4Ryu+iXPR7eVq0MG3BC2+SfJOkzrOPVF22aSOY18U8U3eeO/cpqDpKOKbuFasvXPsY1aejCK9SeT6sMe3Lx7sqKaiiG/iOmbzfYTXDB43EUV+E/ugrfY8u3l6pDuK/CbXvciQ7/O7ZvRYZxQFTUZRkumzHceO2xVFQ5OoHKwp1Z5jMdexjCOKiiYmK28zbVpnnnE4D++6GXn8FBVNLud0VZF1vzwbyTl1J7G3FCVNXppO0kUZLWzvpImpppNYUfbRxFQvvgD3FGUXTV4meY6yhya+ueRhEEBfE/twY06S4YGNuiamHe9F5iUZnCZpa2Lq8YTp3eM8OfTPU9bEXM99BlFmTK9WFGVN+tPBR5RFSe5ziqom5nGG3EeZPZf0EnVNzGDR4BplaRJ9TczTOkoXZXESdU3MaL2tXDiXKGwyThLH4++l7K+JleQdqpo4v16w7ybZxLLijptkS/cv+puslkRPk/knebtpUq14eaCSJituJVqauL+nRBOa0MRGExtNbDSx0cRGExtNbDSxjZo0aXq6SB+/vf/HVOHnOyuhiY0mNprY5DYJ9wOLbRKfw907SN79Cvq1xjQJJpfWxLoWP5hWTJMoC36zx5vXVyn/DvvT8jDk3LLuYnxlUhC+q8V+0ReiSEsSRcdVT4dtibDbx14YkxVtE+Z2j01b+K6M+mnhjtm2HhkAAAAAAAAAAAAAAAAAAAAAAAAAAN/0B81WMJZb1X1AAAAAAElFTkSuQmCC"
                        src={axialImage}
                        ref={(input) => {
                            simpleViewerElement = input;
                        }}></ImageLazyLoad> */}

                </div>
            }
            {state.aixalSliceData.length === 0 &&
                <div style={styles.noDataDiv}> No Data Available</div>}


            <div className="">
                <div className="flex">
                    <div className="pr-2 pl-1 font-semibold self-center w-1/3 text-blue-700">
                        Axial
                    </div>
                    <div className="py-2 text-right right-0 w-2/3">
                        <Stack className="float-right right-2 relative" direction="row" spacing={1} alignItems="center">
                            <Typography sx={{ fontSize: '13px' }}>ML Analysis</Typography>
                            <AntSwitch checked={showOriginal}
                                onChange={() =>
                                    handleToggleClick()
                                }
                                inputProps={{ 'aria-label': 'ant design' }} />
                            <Typography sx={{ fontSize: '13px' }}>Original</Typography>
                        </Stack>

                    </div>
                </div>
                <div className="px-3">
                    <PrettoSlider
                        valueLabelDisplay="auto"
                        aria-label="pretto slider"
                        // defaultValue={state.currentImageIndex}
                        step={1}
                        marks
                        min={1}
                        max={state.aixalSliceData.length}
                        onChange={handleChangeSlider}
                    />
                </div>
            </div>

            {showWindowPortal &&
                (
                    <MyWindowPortal closeWindowPortal={handleSetShowWindowPortal} portalCallback={handleSetShowWindowPortal}>
                        <div className="">
                            {
                                state.aixalSliceData.length > 0 &&
                                <div
                                    className="viewportElement"
                                    style={showWindowPortal ? styles.fulldivStyle : styles.divStyle}
                                >
                                    <div style={styles.topRightStyle}>
                                        <IconButton
                                            color="inherit"
                                            aria-label="Full Screen"
                                            edge="start"
                                            onClick={() => requestFullScreenElem('axial')}
                                        >
                                            <FullscreenIcon />
                                        </IconButton>
                                    </div>
                                    <div style={styles.topLeftStyle}>
                                        <IconButton
                                            color="inherit"
                                            aria-label="New Screen"
                                            edge="start"
                                            onClick={() => requestNewTabWindow('sagittal')}
                                        >
                                            <OpenInNewIcon />
                                        </IconButton>
                                    </div>
                                    <img alt="Thumbnail" className="w-full h-full" src={axialImage}
                                        ref={(input) => {
                                            simpleViewerElement = input;
                                        }}
                                    />

                                </div>
                            }
                            {state.aixalSliceData.length === 0 &&
                                <div> No Data Available</div>}
                            <div className="">
                                <div className="flex">
                                    <div className="px-2 font-semibold self-center w-1/2">
                                        Axial
                                    </div>
                                    <div className="py-2 text-right w-1/2">
                                        <Stack className="float-right right-2 relative" direction="row" spacing={1} alignItems="center">
                                            <Typography>ML Analysis</Typography>
                                            <AntSwitch checked={showOriginal}
                                                onChange={() =>
                                                    handleToggleClick()
                                                }
                                                inputProps={{ 'aria-label': 'ant design' }} />
                                            <Typography>Original</Typography>
                                        </Stack>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </MyWindowPortal>
                )
            }
        </div>
    );
}


export default AxialView;




